module.exports = __webpack_public_path__ + "media/images/titleSponsor--dark-87c5f77e19156f57402dfc61f33d95c9.png";